import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { UserInfoFormValues } from "@/components/HolderForm/UserInfoFormValues.ts";
import { useForm } from "react-hook-form";

export const useHolderInfoForm = () => {
  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
    watch,
    trigger,
    reset,
    getValues,
  } = useForm<UserInfoFormValues>({ mode: "onChange" });

  const watchFirstName = watch([UserInfoFI.FirstName])[0];
  const watchLastName = watch([UserInfoFI.LastName])[0];

  return {
    holderFormData: {
      register,
      handleSubmit,
      errors,
      isValid,
      setValue,
      watch,
      trigger,
      reset,
      getValues,
    },
    watchFirstName,
    watchLastName,
  };
};
